import { withInstall } from '@vuemap/vue-amap-util'
import MapType from './MapType.vue'

export const ElAmapControlMapType = withInstall(MapType)
export default ElAmapControlMapType
